<script>

    import { modalStore } from '../stores'
    export let client = null

</script>

<div class="title">Datos de facturación</div>

<div class="columns">
    <div class="column" style="padding-top: 50px;">
        <div>{ client.name }</div>
        <div>{ client.email }</div>
        <div>{ client.rfc }</div>
        <div>{ client.location.street }, { client.location.number }, { client.location.apartment || '' }</div>
        <div>{ client.location.colony }</div>
        <div><b>{ client.location.zipcode }</b>, { client.location.city }, { client.location.state }</div>
        <div class="items-center space-top">
            <button on:click={() => modalStore.set('facturama_update_client_modal')} class="button">
                <span class="icon"><i class="fas fa-edit"></i></span>
                <span>Actualizar datos</span>
            </button>
        </div>
    </div>    
</div>